import adminHttp from './adminHttp';

/**
 * GET /admin/erp-integration-requests/summary — orgs per ERP inside the admin's
 * managed instances, every catalogue ERP present (zero-filled), sorted by count.
 */
export const fetchErpDemand = async () => {
  const { data } = await adminHttp.get('/admin/erp-integration-requests/summary');
  return data;
};

/** GET /admin/erp-integration-requests — the individual requests, newest first, paged. */
export const fetchErpRequests = async (params) => {
  const { data } = await adminHttp.get('/admin/erp-integration-requests', { params });
  return data;
};
